import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import searchIcon from './../../../../../Assets/icons/searchicon.svg';
import prividegeIcon from './../../../../../Assets/icons/priviledgeIcon.svg';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API'; 
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { IoMdClose } from 'react-icons/io';
import Loader from '../../../../customComponents/CustomLoader';

const UserList = () => {
  const [userData, setUserData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchUserData(newPage);
  };


  const fetchUserData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/user/list', {
        orderBy: 'u.user_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setUserData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const handleSearchInputChange = (event) => {
    const serachvalue= event.target.value
    setSearchTerm(event.target.value);
    if(serachvalue===''){
      fetchUserData()
    }
    
  };
  const TABLE_HEADERS = [
    // "Sr No.",
   
    "User Name",
   
    "Email",
    "Contact No.",
    "DOB",
    
    // "Pincode",
    // "City",
    // "State",
    // "Country",
    // "User Type",
    // "Designation",
    // "Showroom",
    // "Role",
    "Status",
    "Action"
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",
    "User ID": "user_id",
    "User Name": "user_name",
    "Email": "user_email_id",
    "Role": "user_role",
    "Last Name":"user_last_name",
    "Email":"user_email_id",
    "Contact No.":"user_contact_no",
    "DOB":"user_dob",
    "Adress":"user_address",
    "Pincode":"pincode",
    "City":"city_id",
    "State":"state_id",
    "Country":"country_id",
    "User Type":"user_type",
    "Designation":"designation_id",
    "Showroom":"showroom_id",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
      // { type: "priviledge", icon: prividegeIcon, label: "priviledge" },
    ]
  };
  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDIT_USER}`, { state: { data: rowData } });
   
  }
  const handleKeyPress = (e) => {
    console.log("keyname",e.key);
    
    if (e.key === 'Enter') {
      fetchUserData(0, 10, searchTerm); 
    }
  }
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === '') {
      fetchUserData({ searchText: '' });
    }
  }, [searchTerm]);
  const handlePriviledges = (rowData) => {
    
    navigate(`${ROUTES_NAVIGATION.USERLISTPRIVILEDGES}`, { state: { data: rowData } });
   console.log("rowdata", rowData)
  }


  return (
    <>
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>User Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div className='topleftdataContainer'  >
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Users</h6>
          </div>
          <div className='topleftdataContainer'  >
            <h5 className="listTopDataValueText" >{totalActive} </h5>
            <h6>Active Users</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Inactive Users</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-user/user/add-user')}>
              Add User
            </button>
          </div>
        </div>
      </div>
      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Users List</h5>
            <div className="searchinput-wrapper">
              <input 
                type='text' 
                className='searchinput' 
                placeholder={`Search By User Name`} 
                value={searchTerm} 
                onChange={handleSearchInputChange}
                onKeyPress={handleKeyPress} 
              />
              {searchTerm ? (
                <IoMdClose
                  size={22}
                  className="searchinput-close-icon"
                  onClick={clearSearchAndFetch} 
                />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )}
            </div>
          </div>
        </div>
        <CustomTable data={userData} headers={TABLE_HEADERS} keyMapping={keyMapping}   itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit} 
          totalRecords={totalRecords} 
          onPriviledges={handlePriviledges} 

          />
      </div>
      </div>
      )}
  </div></>
  );
};

export default UserList;
